<template>
  <CustomDialog
    :dialog-title="titleText"
    :has-footer="false"
    :has-exit-button="true"
    max-width="37.5rem"
    min-width="37.5rem"
    data-target="cookie-settings-dialog"
    footer-custom-class="!h-auto !py-4 border-t border-slate-200"
    custom-class="!rounded cookie-settings-dialog-modal"
    title-text-class="!text-slate-900 !text-base !font-semibold"
    :body-custom-style="{ padding: '0px' }"
    @cancel="emit('cancel')"
  >
    <div class="h-148 overflow-y-auto">
      <div class="flex flex-col px-5 py-6 gap-5">
        <p class="text-sm font-medium text-slate-600">
          {{ introText }}
        </p>
        <slot name="settings-categories" />
      </div>
    </div>
    <template #footer>
      <div class="flex items-center justify-between w-full">
        <PrimaryButton
          variant="primary-ghost"
          custom-class="px-0 underline text-slate-900 text-sm font-semibold"
          @on-click="emit('acceptAll')"
        >
          {{ acceptAllBtnText }}
        </PrimaryButton>
        <div class="flex items-center gap-3">
          <PrimaryButton
            variant="outline-secondary-neutral"
            custom-class="text-slate-700"
            @on-click="emit('cancel')"
          >
            {{ cancelBtnText }}
          </PrimaryButton>
          <PrimaryButton variant="primary" @on-click="emit('savePreferences')">
            {{ savePreferencesBtnText }}
          </PrimaryButton>
        </div>
      </div>
    </template>
  </CustomDialog>
</template>
<script setup lang="ts">
import CustomDialog from "~/components/shared/custom-dialog/CustomDialog.vue";
import PrimaryButton from "~/components/shared/primary-button/PrimaryButton.vue";
defineProps<{
  titleText: string;
  introText: string;
  acceptAllBtnText: string;
  cancelBtnText: string;
  savePreferencesBtnText: string;
}>();
const emit = defineEmits<{
  cancel: [];
  acceptAll: [];
  savePreferences: [];
}>();
</script>
